import type { GuestRegistrationSource } from "~/domains/user/utils/guestRegistrationData";
import { toGuestRegistrationData } from "~/domains/user/utils/guestRegistrationData";
import type { UserData } from "~/features/inquirySuccess/components/InquirySuccessPage";

export interface InquirySuccessRegistrationInput {
  userInfo: GuestRegistrationSource & {
    line2: string;
    registered?: boolean;
  };
  salesPartner: {
    affiliateId: string;
    subsidiaryId: string;
  };
  marketingConsent: boolean;
  guestCheckoutContext?: string;
}

export function createInquirySuccessUserData({
  userInfo,
  salesPartner,
  marketingConsent,
  guestCheckoutContext,
}: InquirySuccessRegistrationInput): UserData {
  return {
    registered: userInfo.registered ?? false,
    name: `${userInfo.firstName} ${userInfo.lastName}`,
    company: userInfo.company,
    email: userInfo.email,
    address: `${userInfo.line1} ${userInfo.line2}`,
    marketingConsent,
    guestCheckoutContext,
    affiliateId: salesPartner.affiliateId || undefined,
    salesPartnerId: salesPartner.subsidiaryId || undefined,
    affiliatePartnerConfirmed: Boolean(salesPartner.affiliateId),
    guestCheckoutData: toGuestRegistrationData(userInfo),
  };
}
